import React from 'react'
import NavLink from 'components/NavLink'

import './NavBar.css'

export default function NavBar ({ refreshInfo }) {
  return (
    <nav className='NavBar'>
      <ul>
        <li><NavLink href='/'>Activas</NavLink></li>
        <li><NavLink href='/history'>Histórico</NavLink></li>
        <li><button onClick={refreshInfo}>Actualizar</button></li>
      </ul>
    </nav>
  )
}
